import { render, staticRenderFns } from "./RadioSP.vue?vue&type=template&id=09ee9704&scoped=true&"
import script from "./RadioSP.vue?vue&type=script&lang=js&"
export * from "./RadioSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee9704",
  null
  
)

export default component.exports